import { render, staticRenderFns } from "./ReviewSetting.vue?vue&type=template&id=21a912b9&scoped=true"
import script from "./ReviewSetting.vue?vue&type=script&lang=js"
export * from "./ReviewSetting.vue?vue&type=script&lang=js"
import style0 from "./ReviewSetting.vue?vue&type=style&index=0&id=21a912b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a912b9",
  null
  
)

export default component.exports